export const MEDIA_QUERY_MD = "(min-width: 48rem)" as const;
